import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChildcareIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M17 15V10H18.9268L12 0.263672L5.07324 10H7V15H3V24H10V23C10 22.0166 10.748 21 12 21C13.252 21 14 22.0166 14 23V24H21V15H17ZM12 3.71289L15.0498 8H8.95019L12 3.71289H12ZM9 10H15V15H9V10ZM19 22H15.8789C15.4453 20.2559 13.8965 19 12 19C10.1035 19 8.55469 20.2559 8.12109 22H5V17H19V22Z",
    fill: "currentColor"
  }));
}